import { useState } from 'react'
import { useTranslation } from "react-i18next";
import { MdNumbers } from "react-icons/md";
import { TbInputCheck } from "react-icons/tb";
import { TbInputX } from "react-icons/tb";


export default function MathInput({ placeholder, k, onChange }) {

    const {t} = useTranslation();
    const [focused, setfocused] = useState(false);
    const [val, setval] = useState({});
    const [text, settext] = useState("");
    
    function number(type) {

        if (!text) {
            alert(t("math_need_value"));
            return false;
        }
        let ins = {
            key:k,
            type:type,
            value:text,
        };

        setval(ins);

        if (typeof onChange !== 'undefined') {
            onChange(ins);
        }

    }

    

    return (
        <label className={`mathInputValue ${focused ? 'focused' : ""}`}>
            <nav className={`navInputMneu `}>
                <a onClick={() => number("answer")}>{t("answer")}</a>
                <a onClick={() => number("number")}>{t("number")}</a>
            </nav>
            <input type="text" className={val?.type || "null"} onFocus={() => setfocused(true)} onBlur={() => setfocused(false)} onChange={(e) => settext(e?.target?.value)} placeholder={placeholder} />
        </label>
    )
}
